import React from 'react'
import './Crm.css'
import Feedback from './feedback/Feedback'
import Uifooter from './UiFooter/Uifooter'
import Why from './why/Why'
import What from './What/What'
import Industry from './Industry/Industry'
import Whycrm from './Whycrm/Whycrm'
import Herocrm from './Herocrm/Herocrm'
import Service from './service/Services';
import CrmCounter from './crmcounter/CrmCounter';
const Crm = () => {
  return (
    <div id='crm'>
      <Herocrm />
      <Whycrm />
      <What />
      <Why />
       <CrmCounter/>
      <Feedback />
      <Service/>
      {/* 
      <Industry />   
      <Uifooter />  
      */}
      
    </div>
  )
}

export default Crm

